package com.nonopn.skywatcher.common.api

data class ApiProvider<T>(
    val apiAdmin: T?,
    val apiSession: ApiSession,
    val apiNormal: T
)